import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-appointments-history-loader',
  templateUrl: './appointments-history-loader.component.html',
  styleUrls: ['./appointments-history-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentsHistoryLoaderComponent {}
